import axios from 'axios'

const API_PATH = 'api/v2/admins/cms/featured_sellers/favourite_brands'

const CmsFeaturesSellersFavouriteBrandsApiV2 = {

  /**
   * Edit a Cms for Featured Seller
   * Invoke `PATCH api/v2/admins/cms/featured_sellers/:url'
   * @param {string} url - FS url-key
   * @param {object} payload - Payload data to be send to backend
   */
  update: async (url, payload) => {
    const path = `${API_PATH}/${url}`

    const response = await axios.patch(path, payload)

    return response
  }

}

export default CmsFeaturesSellersFavouriteBrandsApiV2
